//polyfill
if (typeof NodeList !== "undefined" && NodeList.prototype && !NodeList.prototype.forEach) {
    // Yes, there's really no need for `Object.defineProperty` here
    NodeList.prototype.forEach = Array.prototype.forEach;
}

function handleFirstTab(e) {
    if (e.keyCode === 9) { // tab
        document.body.classList.add('user-is-tabbing');
    }
}
window.addEventListener('keydown', handleFirstTab);
document.addEventListener("click", function(event){
  //if (event.srcElement && !event.srcElement.classList.contains('visuallyhidden') && event.sourceCapabilities!==null) {
  if (typeof(event.sourceCapabilities)=='undefined' || event.sourceCapabilities!=null) {
    document.body.classList.remove('user-is-tabbing');
  }
});

// Currency selector
function currencyFormSubmit(event) {
  event.target.form.submit();
}
document.querySelectorAll('.currency-selector select').forEach(function(element) {
  element.addEventListener('change', currencyFormSubmit);
});

function profileSnippet(functionHandler, label) {
  if (!label) {
    label = 'Snippet profile time';
  }
  var ini = new Date().getTime();
  functionHandler();
  var end = new Date().getTime();
  console.error(label + ':', (end-ini) +'ms');
}

$(function() {
  	/* Reduced motion: Replace slideToggle(), slideDown(), slideUp() with toggle(), show(), hide() */
  	var oSlideToggle = jQuery.fn.slideToggle;
    jQuery.fn.slideToggle = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.toggle.apply(this, arguments); 
      }else{
      	return oSlideToggle.apply(this, arguments);
      }
    };
    var oSlideDown = jQuery.fn.slideDown;
    jQuery.fn.slideDown = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.show.apply(this, arguments); 
      }else{
      	return oSlideDown.apply(this, arguments);
      }
    };
    var oSlideUp = jQuery.fn.slideUp;
    jQuery.fn.slideUp = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.hide.apply(this, arguments); 
      }else{
      	return oSlideUp.apply(this, arguments);
      }
    };
  	/* End of Reduced Motion */
  
  	jQuery.fn.sortDomElements = (function() {
        return function(comparator) {
            return Array.prototype.sort.call(this, comparator).each(function(i) {
                  this.parentNode.appendChild(this);
            });
        };
    })();
  
  	if(!isMobile.any) {
      $('body').addClass('isNotMobile'); 
    } else {
      $('body').addClass('isMobile'); 
    }

  	$(document).on("click", ".quantity-box .minus", function(e) {
      	e.preventDefault();
      	var input = $(this).parent().find('input[type=number]');
    	try {
          if(input.attr('min')<input.val()) {
          	input.get(0).stepDown();
          	input.change();
          }
        } catch(e) {
          var value = (parseInt(input.val())-1);
          input.val((value>=0 ? value : 0));
          input.change();
        }
  	});
    $(document).on('click','.product-gallery .main-images .active-wrapper.slide', function(e) {     
      if(!$(this).children().hasClass('video-wrap')){
        $(this).closest('.slick-slider').slick('slickNext');
      }
    })
  	$(document).on("click", ".quantity-box .plus", function(e) {
      	e.preventDefault();
      	var input = $(this).parent().find('input[type=number]');
    	try {
          input.get(0).stepUp();
          input.change();
        } catch(e) {
          var value = (parseInt(input.val())+1);
          input.val(value);
          input.change();
        }
  	});

  	/********* QUICK VIEW *********/
  	$(document).on('click', '.product-item .quick-view-trigger', function(){
      var url = $(this).data('url');
      $('#loading-overlay').show();
      $.ajax({
        url: url,
        cache: false
      }).success(function(data){
        Simplistic.openModal(data, ['quick-view-popup', 'translate-y100']);
        setTimeout(function() {
          $('#loading-overlay').hide();
          $('.quick-view-popup').removeClass('translate-y100');
        }, 200);
      });

      return false;
    });

  	if($('#side-cart').length > 0) {
    	initSideCart();
  	}initSelectSample();$('body').delegate('.add-to-cart-form', 'submit', function(){
            if(validateAddCart($(this))) {
              addToCart($(this));
            }
            return false;
        });var utilityBar = $('#header .utility-bar');
    var body = $('body');

    $(window).scroll($.throttle(15, function(){
      if($(this).scrollTop()<=window.innerHeight) {
        $('.scrollup').removeClass('fadein');
      } else {
        $('.scrollup').addClass('fadein');
      }if( $(this).scrollTop()>=80 ) {
          $('.header-drop').addClass('scroll');
        } else {
          $('.header-drop').removeClass('scroll');
        }if( $(this).scrollTop()>=80 ) {
        if (!body.hasClass('scroll') && !body.hasClass('templatePage')) {
          body.addClass('scroll');
          utilityBar.slideUp();        
        }
      } else {
        if (body.hasClass('scroll')) {
          body.removeClass('scroll');
          if (!utilityBar.hasClass('hide-ub')) {
            utilityBar.slideDown();        
          }
        }
      }
    }));

    $('.header-drop .main-menu').html($('#header .main-menu').html());
    $('.header-drop .main-menu a').attr({'focusable':'false','tabindex':'-1','aria-hidden':'true'});
  	setupDropdownMenus();
    $(window).trigger('scroll'); 
  
    $(document).on('click', '.scrollTo', function(){
      var offset = -65;
      if(window.innerWidth > 900){
         offset = -83;
      }
      $.scrollTo($(this).attr('href'), 1000, {offset: offset});
      return false;
    });
});

function setupDropdownMenus(){
  var config = {
    over: function () {
      $(this).find('.submenu:first').slideDown();
      var mm = $('#header');
      mm.attr('submenus-open', (mm.attr('submenus-open')/1 || 0) + 1)
    }, 
    timeout: 400, 
    out: function () {
      $(this).find('.submenu:first').slideUp();
      var mm = $('#header');
      mm.attr('submenus-open', mm.attr('submenus-open')/1 - 1)
    }
  };
  $('.main-menu .has-dropdown').hoverIntent(config);

  $(document).on('keydown', '.main-menu .has-dropdown a:focus', function(e){
    if (e.which == 32) { //Spacebar
      e.preventDefault();
      $(this).next().slideToggle();
    }
    if (e.which == 40) { //Arrow Down
      e.preventDefault();
      $(this).next().slideDown();
    }
    if (e.which == 38) { //Arrow Up
      e.preventDefault();
      $(this).next().slideUp();
    }
  });
  $(document).on('keydown', '.main-menu .has-dropdown .has-dropdown a:focus', function(e){
    if (e.which == 39) { //Arrow Right
      e.preventDefault();
      $(this).next().slideDown();
    }
    if (e.which == 37) { //Arrow Left
      e.preventDefault();
      $(this).next().slideUp();
    }
  });
}

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }
      	
      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
      	return false;
    }
  	return true;
}
function initSelectSample(){
  var samplesAddedToCartCount = 0;
  if($("[js-samples-count]").attr("js-samples-count") != undefined){
    samplesAddedToCartCount = parseInt($("[js-samples-count]").attr("js-samples-count"));
    samplesAddedToCartCount = samplesAddedToCartCount > 2 ? 2 : samplesAddedToCartCount;
  }
  console.log("init: true"+samplesAddedToCartCount);// select swatch
  $(document).on('click', ".selectSample__item-swatch", function(e) {
    if(samplesAddedToCartCount == 2 && $(this).hasClass("added-to-cart") == false){
      $(".selectSample__max-items-msg").addClass("active");
    }else if($(this).hasClass("added-to-cart") == false){
      //ga('send', 'event', 'Mini Popup', 'Shade Selected', $(this).find(".selectSample__item-swatch-text").text());
	  var $item = $(this).parents(".selectSample__item");
      $item.find(".selectSample__item-image img").attr("src",$(this).attr("data-image"));
      $(".selectSample__item-swatch").removeClass("active");
      $(this).addClass("active");
      $(".selectSample__item").removeClass("active");
      $(this).parents(".selectSample__item").addClass("active");
      $item.find(".selectSwatch__caption").html($(this).attr("data-description"));
      $("[js-select-sample]").addClass("swatch-selected");
      var $atc_button = $("[js-add-sample]");
      $atc_button.css("background-color",$(this).attr("data-bg-color")).addClass("swatch-selected");
      $atc_button.attr("data-variant-id",$(this).attr("data-variant-id"));
      samplesAddedToCartCount = samplesAddedToCartCount > 1 ? 1 : samplesAddedToCartCount;
      $atc_button.html("ADD MINI "+(samplesAddedToCartCount+1)+" OF 2");
    }else{
      console.log("before remove: "+samplesAddedToCartCount);
      samplesAddedToCartCount -= 1;
      samplesAddedToCartCount = samplesAddedToCartCount < 0 ? 0 : samplesAddedToCartCount;
      console.log("after remove: "+samplesAddedToCartCount);
     removeSampleToCart($(this).attr("data-variant-id"));
    }
  })
  // hover swatch
  $(document).on('mouseenter', ".selectSample__item-swatch", function(e) {
    var $item = $(this).parents(".selectSample__item");
    $item.find(".selectSwatch__caption").html($(this).attr("data-description"));
  })
  // add sample to cart
   $(document).on('click', "[js-add-sample]", function(e) {
      if($(this).hasClass("updating-js-cart") == false && samplesAddedToCartCount < 3){ 
      $(this).addClass("updating-js-cart");
      samplesAddedToCartCount += 1;
     // ga('send', 'event', 'Mini Popup', 'Shade Added to Cart', $(this).find(".selectSample__item-swatch-text").text());
      addSampleToCart($(this).attr("data-variant-id"));
    }
   })
    // close Alert MSG
   $(document).on('click', "[js-close-msg]", function(e) {
     $(".selectSample__max-items-msg").removeClass("active");
   })
    // mobile NAV
   $(document).on('click', ".selectSample__mobile-nav-item", function(e) {
   	  var id = $(this).attr("data-id");
      $(".selectSample__item").hide();
      $(".selectSample__mobile-nav-item").removeClass("active");
      $(this).addClass("active");
      $("#"+id).show();
   })
   // go to checkout
   $(document).on('click', "[js-go-to-checkout]", function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
   	  window.location.href = "/checkout";
   })
    //close popup
   $(document).on('click', "[js-close-checkout-sample]", function(e) {
   	 $("[js-select-sample]").removeClass("active");
      $("html").removeClass("no-scroll");
   })
   // scroll arrow JS
   $(document).on('click', "[js-scroll-arrow]", function(e) {
   	  var scrollAmount = document.querySelector($(this).attr("data-slide-selector")).offsetWidth;
      var slidesToScroll = parseFloat($(this).attr("data-slides-to-scroll"));
     if($(this).attr("data-pixels-to-scroll") != undefined){
       scrollAmount = parseFloat($(this).attr("data-pixels-to-scroll"));
       slidesToScroll = 1;
     }
      var scrollContainer = document.querySelector($(this).attr("data-container-selector"));
      var currentPosition = scrollContainer.scrollLeft;
      var scrollDirection = $(this).attr("data-scroll-direction");
      var newLeftScroll = scrollDirection == "left" ? currentPosition - (scrollAmount * slidesToScroll) : currentPosition + (scrollAmount * slidesToScroll);
      newLeftScroll = newLeftScroll < 0 ? 0 : newLeftScroll;
      var $this_arrow = $(this);
     $(scrollContainer).animate({
        scrollLeft: newLeftScroll
    },{
        duration: 500,
        complete: function () {
          if(scrollContainer.scrollLeft == 0){
            $this_arrow.hide();
            $this_arrow.siblings('[js-scroll-arrow][data-scroll-direction="right"]').fadeIn(100);
          }else if((scrollContainer.scrollWidth - scrollContainer.clientWidth) == scrollContainer.scrollLeft){
            $this_arrow.hide();
            $this_arrow.siblings('[js-scroll-arrow][data-scroll-direction="left"]').fadeIn(100);
          }else if(scrollContainer.scrollLeft > 0){
            $this_arrow.siblings('[js-scroll-arrow][data-scroll-direction="left"]').fadeIn(100);
            $this_arrow.siblings('[js-scroll-arrow][data-scroll-direction="right"]').fadeIn(100);
          }
        }

      });
     
   })
   
   function addSampleToCart(variant_id){
     jQuery.ajax({
       type: 'POST',
       url: '/cart/add.js',
       data: {
         quantity: 1,
         id: variant_id
       },
       dataType: 'json',           
       success: function() {
         var $atc_button = $("[js-add-sample]");
         $atc_button.removeClass("updating-js-cart");
          if(samplesAddedToCartCount+1 > 2){
          $("[js-select-sample]").addClass("go-to-checkout");
           $("[js-go-to-checkout]").html("CHECKOUT");
          }else{
         $atc_button.html("SELECT MINI "+(samplesAddedToCartCount+1)+" OF 2").removeClass("swatch-selected").css("background-color","#fff");
          }
          $(".selectSample__item-swatch[data-variant-id='"+variant_id+"']").removeClass("active").addClass("added-to-cart");
         
       },
       error: function() {
         alert('Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
       }
     }); 
   }
  function removeSampleToCart(variant_id){
    var data = { updates: {} };
    data.updates[variant_id] = 0;
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function() {
         $("[js-select-sample]").removeClass("go-to-checkout");
         $("[js-go-to-checkout]").html("OR CHECKOUT");
		 var $atc_button = $("[js-add-sample]");
         $atc_button.removeClass("updating-js-cart");
         $atc_button.html("SELECT MINI "+(samplesAddedToCartCount+1)+" OF 2").removeClass("swatch-selected").css("background-color","#fff");
      	 $(".selectSample__item-swatch[data-variant-id='"+variant_id+"']").removeClass("added-to-cart");
      }
    });
  }
}

function showSelectSample(){
  $("html").addClass("no-scroll");
  var $wrapper = $("[js-select-sample]");
  var $carousel = $(".selectSample__carousel");
  var $mobileNav = $(".selectSample__mobile-nav");
  $wrapper.addClass("active");
  var carouselHtml = "<div class='selectSample__prev-item' data-slide-selector='.selectSample__item' data-slides-to-scroll='1' data-container-selector='.selectSample__carousel' data-scroll-direction='left' js-scroll-arrow style='display:none'> <div class='arrow_icon'><img src='https://cdn.shopify.com/s/files/1/0272/5720/8877/files/arrow.svg'></div> </div><div class='selectSample__item animated_gift'><div class='selectSample__item-title'>&nbsp;</div><div class='selectSample__item-image'><img src='https://cdn.shopify.com/s/files/1/0272/5720/8877/files/cropped-minigif-v2.gif'></div></div>";
  var mobileNavHtml = "";
  var itemsCount = 0;
  for (let key in freeMiniSamples){
    if(freeMiniSamples.hasOwnProperty(key)){
     var activeClass = itemsCount == 0 && window.innerWidth < 769 ? ' active' : '';
     itemsCount++;
     var sample = freeMiniSamples[key];
      carouselHtml += "<div class='selectSample__item"+activeClass+"' id='sample-item-"+key+"'><div class='selectSample__item-title'>"+sample.title+"</div><div class='selectSample__item-image'><img src='"+sample.featured_image+"' alt='Free Mini "+sample.title+"'></div><div class='selectSample__item-swatches' id='swatch-carousel-"+key+"'>";
      for (var i = 0; i < sample.variants.length; i++) {
      	var variant = sample.variants[i];
        if(typeof Simplistic.Swatches.Shade[variant.option1] != "undefined" && variant.inventory > 0){
          var simplisticSwatch = Simplistic.Swatches.Shade[variant.option1];
          carouselHtml += "<div class='selectSample__item-swatch' style='background-color:"+simplisticSwatch.swatch+"' data-bg-color='"+simplisticSwatch.swatch+"' data-description='<b>"+variant.option1+"</b> "+simplisticSwatch.description+"' data-image='"+variant.image+"' data-variant-id='"+variant.id+"'><div class='selectSample__item-swatch-text'>"+variant.option1+"</div></div>";
          
        }
      } 
      mobileNavHtml += "<div class='selectSample__mobile-nav-item"+activeClass+"' data-id='sample-item-"+key+"'>"+sample.title+"</div>"
      carouselHtml += "<div class='selectSwatch__prev-item' data-slide-selector='.selectSample__item-swatch'  data-slides-to-scroll='4' data-container-selector='#swatch-carousel-"+key+"' data-scroll-direction='left' js-scroll-arrow style='display:none' data-pixels-to-scroll='144.6'><div class='selectSwatch__arrow_icon'></div></div><div class='selectSwatch__next-item' data-slide-selector='.selectSample__item-swatch'  data-slides-to-scroll='4' data-pixels-to-scroll='144.6' data-container-selector='#swatch-carousel-"+key+"' data-scroll-direction='right' js-scroll-arrow><div class='selectSwatch__arrow_icon'></div></div></div><p class='selectSwatch__caption'></p></div>";
    }
  }
  carouselHtml += "<div class='selectSample__next-item' data-slide-selector='.selectSample__item' data-slides-to-scroll='1' data-container-selector='.selectSample__carousel' data-scroll-direction='right' js-scroll-arrow > <div class='arrow_icon'><img src='https://cdn.shopify.com/s/files/1/0272/5720/8877/files/arrow.svg'></div> </div>";
  $carousel.html(carouselHtml);
  $mobileNav.html(mobileNavHtml);
  $carousel.append($mobileNav);
  window.dispatchEvent(new CustomEvent("selectSampleLoaded"));
  // detect scroll
  calculateScrollDivs();
}
function calculateScrollDivs(){
  $("[js-scroll-arrow]").each(function() {
    var scrollContainer = document.querySelector($(this).attr("data-container-selector"));
    var $this_arrow = $(this);
    if(scrollContainer.scrollWidth == scrollContainer.clientWidth){
      $this_arrow.siblings('[js-scroll-arrow][data-scroll-direction="left"]').hide();
      $this_arrow.siblings('[js-scroll-arrow][data-scroll-direction="right"]').hide();
    }
  });
}
function initSideCart() {
	$('.header .cart-wrap').click(function(e){
    if ($(this).find('.count').data('count')===0) {
      e.stopPropagation();
      showSideCart(true);
      return false;
    }
  });

  $(document).click(function(event){
    if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="loading-overlay" && $('#side-cart').hasClass('open')) {
      hideSideCart();
    }
  });
}

function addToCart(form, callback){
	$('#loading-overlay').show();
  	if(modal) modal.close();
  
  	var productJs = form.closest('.initialized').data('productjs');
  	if(productJs) {
    	$(document).trigger("addToCart", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
    } else {
    	$(document).trigger("addToCart", [form]);
    }
  
	$.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: addToCartFail,
      success: function(data){
        if(productJs) {
          $(document).trigger("addToCartSuccess", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
        } else {
          $(document).trigger("addToCartSuccess", [form]);
        }
        if(callback) {
          callback();
        } else {
          addToCartSuccess();
        }
      },
      cache: false
	});
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
	updateCartDesc(true);
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  	var response = $.parseJSON(jqXHR.responseText);
  	$('#loading-overlay').hide();
  	Simplistic.openModal('<div class="error-itemincart">'+response.description+'</div>', 'message');
}

function updateCartDesc(openSideCart){
  	$.ajax({
		type: 'GET',
		url: '/cart?view=side-cart',
		cache: false,
      	success: function(data){
          $('#loading-overlay').hide();

          var animate = true;
          if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
            animate = false;
          } else {
            data = data.replace('var updateFreeShippingDelay = 100', 'var updateFreeShippingDelay = 500');
          }
          $('#side-cart').remove();
          $('#page').append(data);
          if(modal) modal.close();
          if(openSideCart){
            showSideCart(animate);
          }
      	}
	});
}

function showSideCart(animate) {
  $('body, html').css({overflow: 'hidden'});
  $('#page').addClass('mode-overlay');
  if(animate) {
    setTimeout(function(){$('#side-cart').addClass('open')}, 100);
  } else {
    $('#side-cart').removeClass('ease-animation-slow');
  	$('#side-cart').addClass('open');
    setTimeout(function(){$('#side-cart').addClass('ease-animation-slow')}, 200);
  }
  Simplistic.trapFocus({
    $container: $('#side-cart'), 
    namespace: 'side-cart'
  });
}

function hideSideCart() {
  $('#side-cart').removeClass('open');
  $('#page').removeClass('mode-overlay');
  $('body, html').css({overflow: ''});
  Simplistic.removeTrapFocus({
    $container: $('#side-cart'), 
    namespace: 'side-cart'
  });
}

window.SimplisticJS = function (){
  var selfSJS = this;
  this.formatMoney = "$\{\{amount\}\}";
  this.beforeTrapFocus = [];
  
  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.trapFocus = function(options) {
    selfSJS.beforeTrapFocus.push($(':focus'));
    var trapIndex = selfSJS.beforeTrapFocus.length;
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (selfSJS.beforeTrapFocus.length==trapIndex) {
        if (
          options.$container[0] !== evt.target &&
          !options.$container.has(evt.target).length
        ) {
          options.$container.focus();
        }
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    var before = selfSJS.beforeTrapFocus.pop();
    if(before) {
    	before.focus();
    }

    $(document).off(eventName);
  }

  this.handleizeTry = function (str) {
    console.log('Handleize: ' +str + '\nWould be: '+selfSJS.handleize(str));
    return str;
  };
  
  this.handleize = function (str) {
    //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  };
  
  this.reducedMotion = function() {
  	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  this.getQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  this.randomstring = function(L){
    var s= '';
    var randomchar=function(){
      var n= Math.floor(Math.random()*62);
      if(n<10) return n; //1-10
      if(n<36) return String.fromCharCode(n+55); //A-Z
      return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) s+= randomchar();
    return s;
  }

  this.validateEmail = function(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  this.openImageOnModal = function(imgUrl, popupClassName) {
    selfSJS.openModal('<div class="popup-content"><div class="loader"></div></div>', ['generic-popup', popupClassName]);
    var img = new Image();
    img.style.width = '100%';
    img.onload = function() {
      $('.tingle-modal .popup-content').html('').append($(img));
    };
    img.src = imgUrl;  
  }

  this.openModal = function(content, css, otherOptions) {
    var config = {
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: typeof(css)=='string' ? [css] : css,
      beforeOpen: function() {
        $(".tingle-modal__close").appendTo(".tingle-modal-box__content");
      },
      beforeClose: function() {
    	  $(".tingle-modal__close").prependTo(".tingle-modal");
        /*
        //currently onClose of vendor.js
        Simplistic.removeTrapFocus({
          $container: $('.tingle-modal'), 
          namespace: 'tingle-modal'
        });*/
        return true;
      }
    };
    if (otherOptions) {
      $.extend(config, otherOptions);
    }
    modal = new tingle.modal(config);
    modal.setContent(content);
    modal.open();
    //currently onOpen of vendor.js but not working
    Simplistic.trapFocus({
      $container: $('.tingle-modal'), 
      namespace: 'tingle-modal'
    });

  }

  this.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    var loadFunction = function() {
      imagesLoaded++;
      if(imagesLoaded==images.length) {
        callback();
      }
    };
    if(images.length>0) {
      images.each(function(){
        var img = new Image();
        img.onload = loadFunction;
        img.onerror = loadFunction;
        img.src = $(this).attr('src');
      });
    } else {
      callback();
    }
  };

  this.addInfoIcon = function(container, content, linkWholeContainer) {
    container.find('.info-icon').remove();
    var icon = $('<span class="info-icon">i</span>');
    container.append(icon);
    var link = icon;
    if (linkWholeContainer) {
      link = container;
    }
    link.click(function(event) {
      event.stopImmediatePropagation();
      Simplistic.openModal(content, 'swatch-info');
    });

  }

  this.loadProductUI = function (productItem) {
    var swatchesCustom = productItem.find('.swatch.custom');
    var productJs = productItem.data('productjs');
    var product = productJs.getProduct();
    var mainImagesSlider = productItem.find('.main-images');
    var thumbsSlider = productItem.find('.thumbs');
    var addToCartButtonDefaultCaption = 'Add To Cart';
    var bucketShades = productItem.find('.swatches-board-categories .swatch-category');
    var allShades = productItem.find('.bucket-shade .swatch-element');

    if (bucketShades) {
      bucketShades.on('click', function(event) {
        bucketShades.each(function(ix, el) {
          el.classList.remove('active');
        })
        event.target.classList.add('active');

        var range = event.target.dataset.range;
        if (!range) {
          allShades.each(function(ix, el) {
            el.style.display = 'block';
          })
        } else {
          var rangeMin = parseInt(range.split('-')[0]);
          var rangeMax = parseInt(range.split('-')[1]);

          allShades.each(function(ix, el) {
            el.style.display = 'block';
          })
          allShades.each(function(ix, el) {
            // This needs to change to a split and select the second part to select number: [name number]
            var val = parseInt(el.dataset.value.split(' ')[1])
            //var val = parseInt(el.dataset.value.substring(1));
          
            if (val >= rangeMin && val <= rangeMax) {
              el.style.display = 'block';
            } else {
              el.style.display = 'none';
            }
          })
        }
      })
    }

    function updateSliderArrows(slideIndex) {
      var thumbs = productItem.find('.thumbs.slick-slider');
      if (thumbs.length > 0) {
        var prevArrow = thumbs.find('.up-arrow.slick-arrow, .left-arrow.slick-arrow');
        var nextArrow = thumbs.find('.down-arrow.slick-arrow, .right-arrow.slick-arrow');
        var slides = thumbs.find('.slide');
        if (slides.first().hasClass('slick-active')) {
          prevArrow.hide();
        } else {
          prevArrow.show();
        }
        if (slides.last().hasClass('slick-active')) {
          nextArrow.hide();
        } else {
          nextArrow.show();
        }
      }
    }
    thumbsSlider.on('afterChange', function(event, slick, currentSlide) {
      updateSliderArrows();
    });

    //set swatches background
    swatchesCustom.each(function(ix, swatch) {
      var $swatch = $(swatch);
      var swatchName = $swatch.data('swatch');
      var swatchConfig = Simplistic.Swatches[swatchName];
      
      if (swatchConfig) {
        if (swatchConfig._info) {
          var infoIcon = $('<span class="info-icon">i</span>');
          $swatch.find('.head').append(infoIcon);
          infoIcon.click(function(event) {
            event.stopImmediatePropagation();
            Simplistic.openModal(swatchConfig._info, 'swatch-info');
          });
        }
        
        $swatch.find('.swatch-element').each(function(ix2, elem) {
          var $elem = $(elem);
          var optionValue = $elem.data('value');
          var label = $elem.find('label');
          if(swatchConfig[optionValue]) {
            var value = (typeof swatchConfig[optionValue].texture_img === 'undefined') ? swatchConfig[optionValue].swatch : swatchConfig[optionValue].texture_img;
            var valueParts = value.split(' ');
            if (value.indexOf('http')>-1) {
              label.css('background-color', 'initial');
              label.css('background-image', "url('"+valueParts[0]+"')")
            } else {
              label.css('background-color', valueParts[0]);
            }
          } else {
            console.error('Undefined custom swatch: '+swatchName+' - '+optionValue);
          }
        });
        $('.swatch').find('.swatch-element input')[0].click();
      }

    });

    productItem.find('.options .swatch').addClass('panel').each(function(ix, swatch) {
      swatch.validateComplete = function() {
        return $(this).hasClass('selected') ? '' : $(this).data('select-caption')+' '+$(this).data('swatch');
      }
    });
    productItem.find('.swatch.custom-tpl1, .swatch.custom-tpl2').each(function(ix, swatch) {
      swatch = $(swatch);
      var elementDescription = swatch.find('.swatch-element-description .hover');
      var selectedElementDescription = swatch.find('.swatch-element-description .selected');
      swatch.find('.swatch-element').on('mouseleave', function() {
        elementDescription.html('');
        selectedElementDescription.show(); //REF: wa_1, workaround for IE11, remove when no longer supported
      });
      swatch.find('.swatch-element').on('mouseenter', function() {
        var optionValue = $(this).find('input').val();
        var swatchName = $(this).closest('.swatch').data('swatch');
        if(Simplistic.Swatches[swatchName] && Simplistic.Swatches[swatchName][optionValue]) {
          var swatchDesc = Simplistic.Swatches[swatchName][optionValue].description;
          if(typeof product != "undefined"){
            optionValue = optionValue == "Refill Only" ? optionValue + " - "+ product.title + " Refills " : optionValue;
          }
          var description = '';
          if (swatchDesc) {
            description = optionValue + ' <span class="swatch-description">'+ swatchDesc + '</span>';
          }
        }
        selectedElementDescription.hide(); //REF: wa_1, workaround for IE11, remove when no longer supported

        elementDescription.html(description);
      });

    });

    function updateSwatchPrice(swatch, selectedVariant) {
      var optionIndex = swatch.data('option-index');
      var selectedValue = swatch.find(':radio:checked').val();
      $(product.variants).each(function(ix, variant) {
        var matchSelection = true;
        for (var i=0; i<product.options.length; i++) {
          if (i!=optionIndex) {
            if (variant.options[i]!=selectedVariant.options[i]) {
              matchSelection = false;
            }
          }
        }
        if (matchSelection) {
          var priceElem = swatch.find('.swatch-element[data-value="'+variant.options[optionIndex]+'"] .variant-price .money');
          priceElem.html(Shopify.formatMoney(variant.price, Simplistic.formatMoney).replace('.00', ''));
          if (swatch.hasClass('use-variant-image')) {
            var label = swatch.find('.swatch-element[data-value="'+variant.options[optionIndex]+'"] label');
            var imgCss = '';
            if (!label.data('backgroundimage')) {
              label.data('backgroundimage', label.css('background-image'));
            }
            if (variant.featured_image) {
              var imgUrl = Simplistic.addImageFilter(variant.featured_image.src, '200x');
              imgCss = 'url("'+imgUrl+'")';
            } else {
              imgCss = label.data('backgroundimage');
            }

            //workaround for Android Chrome bug, clear bg image then set it after 1ms. Date 2021-01-20, Ref: MOB-109
            //label.css('background-image', imgCss);
            label.css('background-image', ''); 
            setTimeout(function() {
              label.css('background-image', imgCss);
            },1);
          }
        }
      });
    }
    
    productItem.on('swatchSelected', function() {
      updateAddToCartUI();
    });

    function updateAddToCartUI() {
      var validationMsg = '';
      var nextStep = '';
      if (!productItem.find('.options').hasClass('hide-options')) {
        productItem.find('.swatch').each(function(ix, swatch) {
          var $swatch = $(swatch);
          if (swatch.validateComplete) {
            validationMsg = swatch.validateComplete();
            if (validationMsg!='') {
              nextStep = 'Select ' + $swatch.data('swatch');
              return false;
            }
          }
        })
      }

      var button = productItem.find('[name="add"]');
    
      if (nextStep) {
        button.find('.btn-add-text').html(nextStep);
        button.attr('disabled', 'disabled');
      } else {
        button.find('.btn-add-text').html(button.data('default-caption') || addToCartButtonDefaultCaption);
        button.attr('disabled', false);
      }
    }

    function updateUI(selectedVariant) {
      updateSliderArrows();
      swatchesCustom.each(function(ix, swatch) {
        var $swatch = $(swatch);
        var swatchName = $swatch.data('swatch');
        var optionIndex = $swatch.data('option-index');
        var optionValue = selectedVariant.options[optionIndex];
        if ($swatch.hasClass('custom-tpl1') || $swatch.hasClass('custom-tpl2')) {
          if(Simplistic.Swatches[swatchName] && Simplistic.Swatches[swatchName][optionValue]) {
            var swatchDesc = Simplistic.Swatches[swatchName][optionValue].description;
            var description = '';
            if(typeof product != "undefined"){
              optionValue = optionValue == "Refill Only" ? optionValue + " - "+ product.title + " Refills " : optionValue;
            }
            if (swatchDesc) {
              description = optionValue + ' <span class="swatch-description">'+ swatchDesc +'</span>';
            }
            $swatch.find('.swatch-element-description .selected').html(description);
          }

        }
        if ($swatch.hasClass('custom-tpl2')) {
          updateSwatchPrice($swatch, selectedVariant);
        }

      });
      var skusContainer = productItem.find('.skus');
      skusContainer.html('');
      if (selectedVariant.sku) {
        var skus = selectedVariant.sku.split('_');
        skus.forEach(function(sku, index) {
          skusContainer.append($('<input type="hidden" name="properties[_sku_'+(index +1)+']" value="'+sku+'"/>'));
        });
      }
      
      updateAddToCartUI();
    }


    productItem.on('variantChange', function(event, variant) {
      updateUI(variant);
    });
    updateUI(productItem.data('productjs').getCurrentVariant());

   }

  this.loadCartUI = function() {

    /********* SPECIAL INSTRUCTIONS NOTE *********/
    var checkInstructions = function() {
      if($('#chk-instructions').is(':checked')) {
        $('#instructions-note').show();
      } else {
        $('#instructions-note').hide();
        $('#instructions-note').find('textarea').val("");
      }
    }
    $(document).on('click', '#chk-instructions',function(){
      checkInstructions();
    });
    checkInstructions();

    $(document).on('click', '#cart .remove', function(){
      updateCartItem($(this).closest('.item').data('key'), 0);
      return false;
    });

    $(document).on('change', '#cart input[type=number]', function(){
      updateCartItem($(this).closest('.item').data('key'), $(this).val());
    });

    function removeItems(items) {
      $('#loading-overlay').show().focus();
  
      var data = {updates: {}}
      items.each(function(ix,item) {
        data.updates[$(item).data('key')] = 0;
      });
      postUpdate({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json'
      });
    }

    $(document).on('click', '#cart .remove-bundle', function(){
      var items = $(this).closest('.items-bundle').find('.item[data-key]');
      removeItems(items);
    });

    function postUpdate(ajaxOptions) {
      $.ajax(ajaxOptions).fail(function(){console.log('error'); location.reload();}).done(function(data){
        var SimplisticCartLoaded = new CustomEvent("SimplisticCartLoaded", { "detail": data});
        window.dispatchEvent(SimplisticCartLoaded);
        $.ajax({
          type: 'GET',
          url: '/cart?view=update',
          cache: false,
          success: function(data){
            $('#loading-overlay').hide();
            $('#cart').remove();
            $('.content-wrapper').prepend(data);
            checkInstructions();
            Simplistic.updateFreeShipping($('#cart [data-total-price]').data('total-price'));
          }
        });
        updateCartDesc();
        $('#add-cart-overlay').fadeOut();
      });
    }

    /********* UPDATE QUANTITY WITHOUT REFRESHING *********/
    function updateCartItem(key, quantity){
      $('#loading-overlay').show().focus();

      postUpdate({
        type: 'POST',
        url: '/cart/change.js?id='+key+'&quantity='+quantity,
        data: '',
        dataType: 'json'
      });
    }/********* EDIT ITEM *********/
    $(document).on('click', '#cart .edit-item', function(){
      var url = $(this).data('url');
      var qty = $(this).data('qty');
      var variantId = $(this).data('variant');
      var itemKey = $(this).data('item-key');

      $('#loading-overlay').show();

      $.ajax({
        url: url,
        cache: false
      }).success(function(data){
        $('#loading-overlay').hide();
        Simplistic.openModal(data, 'quick-view-popup');
        $('.quick-view [name=quantity]').val(qty).change();
        $('.quick-view [name="add"]').data('default-caption', 'SAVE CHANGES');
        $('.quick-view .initialized').on('productLoaded', function(){
          $('.quick-view .initialized').data('productjs').setVariant(variantId);
        });

        $('.quick-view .add-to-cart-form').submit(function(){
          if(modal) modal.close();

          var form = $(this);
          if (form.find('[name="id"]').val()==variantId) {
            //user picked same variant
            return false;
          }

          $('#loading-overlay').show();
          addToCart(form, function(){
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: {id: itemKey, quantity: 0}
            }).success(function(){
              location.reload();
            });
          });
          return false;
        });
      });
      return false;
    });//check & remove broken bundles, sometimes main product is missing
    $('#cart .items-bundle').each(function(ix, div) {
      if ($(div).find('.remove-bundle').length==0) {
        var items = $(div).find('.item[data-key]');
        removeItems(items);
      }
    });
  }


  //error codes:
  //1: when palette is full
  //2: when only a half width Shade (like Eyeshadow) can be added
  //3: when resizing to smaller palette that can't hold the current shades selection
  //4: when trying to add face shades to Compact 1+, the customer should just purchase in that shade PDP.

  this.initProductItems = function() {
    $('.product-item').not('.initialized').each(function(ix, item){
      var item = $(item);
      item.addClass('initialized');
      if (item.hasClass('in-carousel')) {
        return;
      }
      var selector = '.product-item[data-productid="'+item.data('productid')+'"]';

      inView(selector).once('enter', function() {
        if (isMobile.any) {
          //2nd image hover(desktop)/slider(mobile)
          var slider = item.find('.image');
          slider.find('.lazyload').each(function(ix2, img) {
            lazySizes.loader.unveil(img);
          });
          var iID = setInterval(function() {
            if (slider.find('.lazyloading, .lazyload').length==0) {
              clearInterval(iID);
              slider.slick({
                arrows: false,
                dots: true,
                waitForAnimate: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<a class="left-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 32 32"><path fill="#101820" d="M24.333 28.205l-1.797 1.684L7.666 16l14.87-13.889 1.797 1.675L11.269 16z"/></svg></a>',
                nextArrow: '<a class="right-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 32 32"><path fill="#101820" d="M7.667 3.795l1.797-1.684L24.334 16 9.464 29.889l-1.797-1.675L20.731 16z"/></svg></a>'
              });
              slider.removeClass('notinview');
            }
          }, 100);
        } else {
          $('.product-item .image').removeClass('notinview');
        }

        //swatches
        item.find('.swatch.custom').each(function(ix, swatch) {
          var swatch = $(swatch);
          var swatchName = swatch.data('option');
          var swatchConfig = Simplistic.Swatches[swatchName];
          swatch.find('.swatch-element .img').each(function(ix2, elem) {
            var elem = $(elem);
            var optionValue = elem.data('value');
            if(swatchConfig && swatchConfig[optionValue]) {
              var value = swatchConfig[optionValue].swatch;
              var valueParts = value.split(' ');
              if (value.indexOf('http')>-1) {
                elem.css('background-color', 'initial');
                elem.css('background-image', "url('"+valueParts[0]+"')")
              } else {
                elem.css('background-color', valueParts[0]);
              }
            }

          });
        });

      });

    });
  }

  this.matchHeight = function (elements) {
    var height = 0;
    elements.each(function(ix, e) {
      $(e).css('min-height', '');
    });
    elements.each(function(ix, e) {
      height = Math.max(height, $(e).outerHeight());
    });
    elements.each(function(ix, e) {
      $(e).css('min-height', height);
    });
  }

  this.onWidthChange = function(callback, delay, abortDelayedCalls) {
    var lastWidth = 0;
    var tID = 0;
    $(window).resize(function() {
      if (lastWidth != window.innerWidth) {
        lastWidth = window.innerWidth;
        if (abortDelayedCalls) {
          clearTimeout(tID);
        }
        tID = setTimeout(callback, delay);
      }
    })
  }

  
  var freeshippingIds = 0;
  this.updateFreeShipping = function(total) {
    freeshippingIds++;
    var minAmount = parseFloat("50") * 100;
    if (window.CurrencyConversionRate && window.CurrencyConversionRate!=1) {
      minAmount = Math.ceil(minAmount / 100 * window.CurrencyConversionRate) * 100;
    }
    $('.freeshipping').not('.initialized').addClass('initialized freeshipping-id-'+freeshippingIds).each(function(ix, elem) {
      var freeShippingContainer = $(elem);
      freeShippingContainer.append($('<div class="freeshipping-bar body_font2"><div class="progress ease-animation-slow"></div></div>')).append($('<div class="freeshipping-title"></div>'));
      inView('.freeshipping-id-'+freeshippingIds).on('enter', function() {
        setTimeout(function() {
          var innerBar = freeShippingContainer.find('.freeshipping-bar .progress');
          innerBar.css('width', innerBar.data('progress'));
        }, 200);
      });

    });
    var progress = '100%';
    if (total<minAmount) {
      $('.freeshipping-title').html('<span class="money">'+Shopify.formatMoney(minAmount - total, Simplistic.formatMoney).replace('.00', '')+'</span> away from free shipping!')
      progress = (total/minAmount*100)+'%';
    } else {
      $('.freeshipping-title').html('Free shipping unlocked')
    }
    $('.freeshipping').show();
    $('.freeshipping-bar .progress').data('progress', progress);
    $('.freeshipping').each(function(ix, elem) {
      if (!$(elem).hasClass('custom-animated') || inView.is(elem)) {
        $(elem).find('.freeshipping-bar .progress').css('width', progress);
      }
    });

  }
  

  this.removeCartItem = function(itemKey, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {id: itemKey, quantity: 0}
    }).success(function(){
      if (callback)
      callback();
    });
  }
  $(function() {
    $(document).on('click', '.featured-products-atc', function(){
      var products = $(this).closest('.featured-products-items');
      var item = $(this).closest('.featured-products-item');
      var qty = 1;
      var variantId = item.find('[data-name="id"]').val();
      var addedItem = products.find('.featured-products-item[data-key]');
      $('#loading-overlay').show();
      if (addedItem.data('key') && item.data('key')==addedItem.data('key')) {
        //just remove item
        selfSJS.removeCartItem(addedItem.data('key'), function() {cartRefresh()});
        return;
      }

      function cartRefresh() {
        if (location.href.indexOf('/cart')>=0) {
          location.reload();
        } else {
          addToCartSuccess();
        }
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        error: addToCartFail,
        data: {id: variantId, quantity: qty}
      }).success(function(){
        if (addedItem.data('key')) {
          selfSJS.removeCartItem(addedItem.data('key'), function() {cartRefresh()});
        } else {
          cartRefresh()
        }
      });

    });
  });

  this.staticPageInit = function() {
    //init nav
    var anchors = $('.page .content .anchor');
    var nav = $('.page .nav');
    anchors.each(function(ix, item) {
      var anchor = $(item);
      var title = anchor.next().text();
      var navItem = $('<div class="nav-item"><a class="nav-item-title" href="#'+item.id+'">'+ title +'</a></div>');
      nav.append(navItem);
      navItem.find('.nav-item-title').click(function(event) {
        $.scrollTo('#'+item.id, 300);
        return false;
      })
    })

  }

  this.pageAboutUsInit = function(section) {
    selfSJS.initScrollHandle({ignoreOnResize: true});
    selfSJS.initMediaQueryHandle();

    section.find('.multi_image_text .item-inner').each(function(ix, item){
      item = $(item);
      if (item.find('.content-wrap').length>0) {
        item.addClass('enabled');

        var config = {
          over: function () {
            if (window.innerWidth>=901) {
              if (item.closest('.grid').hasClass('desktop-layout-grid') || item.closest('.grid').hasClass('desktop-layout-slider')) {
                item.find('.content-wrap').addClass('open');
              }
            } else {
              if (item.closest('.grid').hasClass('mobile-layout-grid') || item.closest('.grid').hasClass('mobile-layout-slider')) {
                item.find('.content-wrap').addClass('open');
              }
            }
          }, 
          timeout: 100, 
          out: function () {
            if (window.innerWidth>=901) {
              if (item.closest('.grid').hasClass('desktop-layout-grid') || item.closest('.grid').hasClass('desktop-layout-slider')) {
                item.find('.content-wrap').removeClass('open');
              }
            } else {
              if (item.closest('.grid').hasClass('mobile-layout-grid') || item.closest('.grid').hasClass('mobile-layout-slider')) {
                item.find('.content-wrap').removeClass('open');
              }
            }
          }
        };
        item.hoverIntent(config);

      }
    });
    var miSliders = section.find('.multi_image_text .desktop-layout-slider, .multi_image_text .mobile-layout-slider');
    function layoutSliders() {
      miSliders.filter('.slick-slider').slick('unslick');
      if (window.innerWidth>=901) {
        miSliders.filter('.desktop-layout-slider').slick({slidesToShow: 2, arrows: false, dots: false, centerMode: true, centerPadding: '15% 0 0'});
      } else {
        miSliders.filter('.mobile-layout-slider').slick({slidesToShow: 2, arrows: false, dots: false, centerMode: true, centerPadding: '15% 0 0'});
      }
      $(window).trigger('layoutChange');
    }
    $(window).on('mediaChange', layoutSliders);
    layoutSliders();

    function buildIndex(section) {
      var modules = section.find('.module');
      var titles = '';
      section.find('.module-title').each(function(ix, title) {
        $(title).find('a').addClass('clone');
        titles += title.outerHTML;
      });
      modules.each(function(ix, module) {
        var container = $(module).find('.module-header .block-inner.desktop');
        container.html(titles);
        var origTitle = container.find('.module-title:eq('+ix+')');
        origTitle.find('a').removeClass('clone').addClass('orig');
        $('<div class="module-nav"></div>').insertAfter(origTitle);
      });
      modules.each(function(ix, module) {
        module = $(module);
        var titles = module.find('.indexed');
        var nav = module.find('.module-nav');
        titles.each(function(ix2, title) {
          title = $(title);
          nav.append('<a href="#'+title.data('rel')+'">'+title.text()+'</a>')
        })
      })

      function buildMobileMenu() {
        modules.each(function(ix, module) {
          module = $(module);
          var container = module.find('.block-inner.mobile');
          modules.each(function(ix2, module2) {
            module2 = $(module2);
            var nav = module2.find('.desktop .module-nav');
            if (ix2==ix) {
              container.prepend(nav.clone());
              container.prepend(nav.prev().clone());
            } else {
              container.append(nav.prev().clone());
              container.append(nav.clone());
            }
          })
        })
        
      }
      buildMobileMenu();

      var navItems = section.find('.module-header a[href^="#"]');
      navItems.click(function(event) {
        var href = $(this).attr('href');
        if (window.innerWidth<901) {
          var dst = $(href);
          var modHeader = $(this).closest('.module-header');
          modHeader.removeClass('open');
          $('#header').removeClass('transparent');
          $('body, html').css({overflow: ''});
          Simplistic.removeTrapFocus({
            $container: $('.module-header'), 
            namespace: 'module-header'
          });
          setTimeout(function() {
            modHeader.removeClass('visible');
            switchModule(dst.closest('.module'));
            $.scrollTo(href, 600);
          }, 300);
        } else {
            $.scrollTo(href, 600);
        }

        //Simplistic.replaceHash(href); //hash updated by scroll event
        return false;
      });

      //fix page menu links with bookmarks to the current page
      (function() {
        var currentUrl = location.href.substr(0, location.href.indexOf('#')==-1 ? location.href.length : location.href.indexOf('#'));
        var links = document.querySelectorAll('a[href^="'+location.origin+location.pathname+location.search+'#"], a[href^="'+location.pathname+location.search+'#"]');
        links.forEach(function(link) {
          $(link).click(function() {
            /*
            if (window.innerWidth<901) {
              setTimeout(function() {
                location.reload();
              },50);
            }
            */
            var dst = link.href.substr(link.href.indexOf('#'));
            if ($(link).closest('.menu-mobile').length>0) {
              window.closeMenuMobile()
            }
            var dstLink = null;
            if (window.innerWidth<901) {
              dstLink = $('.module.active .module-header a[href^="'+dst+'"]').first();
            } else {
              dstLink = $('.module-header a[href^="'+dst+'"]').first();
            }
            
            if (dstLink) {
              dstLink.click();
              return false;
            }
          })
        })
      })();

      var navItemsNotCloned = section.find('.module-header .desktop a[href^="#"]').not('.clone');
      function calcIndexedItemsOffset() {
        navItemsNotCloned.each(function(ix, item) {
          item = $(item);
          var dstElem = $(item.attr('href'));
          item.data('dst-top', dstElem.offset().top);
        })
      }
      $(window).on('resizeWidth layoutChange', calcIndexedItemsOffset);
      calcIndexedItemsOffset();

      var instaFeed = $('#_insta-feed');
      instaFeed.attr('href', '#_insta-feed');

      function markIndex() {
          var currentNavItems = navItemsNotCloned;
          if (window.innerWidth<901) {
            currentNavItems = mobileNavItemsNotCloned;
          }
          var lastItem = currentNavItems.first();
          if (instaFeed.length>0) {
            instaFeed.data('dst-top', instaFeed.offset().top );
            currentNavItems = currentNavItems.add(instaFeed);
          }
          var top = $(window).scrollTop() + 20;
          (function() {
            currentNavItems.removeClass('active').each(function(ix, item) {
              item = $(item);
              if (item.data('dst-top')>top) {
                return false;
              }
              lastItem = item;
            })
          })()
          if (lastItem) {
            lastItem.addClass('active');
            if (window.innerWidth>=901) {
              modules.removeClass('active');
              lastItem.closest('.module').addClass('active');
            }
            if (section.hasClass('initialized')) {
              Simplistic.replaceHash(lastItem.attr('href'));
            }
          }
      }
      function updateMobileNav(text) {
        var mobileNav = modules.filter('.active').find('.mobile-nav .text');
        mobileNav.html(text);
      }
      var currentModule = null;
      var mobileNavItemsNotCloned = null;
      function switchModule(module) {
        if (!currentModule || currentModule[0] != module[0]) {
          if (currentModule) {
            currentModule.removeClass('active');
          }
          currentModule = module;
          currentModule.addClass('active');
          mobileNavItemsNotCloned = currentModule.find('.module-header .desktop a[href^="#"]').not('.clone');
          updateMobileNav(modules.filter('.active').find('.module-title .orig').html());
          layoutSliders();
        }
      }
      $(window).on('scrollEnd', markIndex);
      switchModule(modules.first());
      markIndex();
      modules.find('.mobile-nav button').click(function() {
        var modHeader = $(this).closest('.module').find('.module-header');
        var button = $(this)
        modHeader.addClass('visible');
        setTimeout(function() {
          modHeader.addClass('open');
          $('#header').addClass('transparent');
          $('body, html').css({overflow: 'hidden'});
          Simplistic.trapFocus({
            $container: $('.module-header'), 
            namespace: 'module-header'
          });
        }, 1);
      })

      function scrollToHash() {
        if (location.hash) {
          var dst = $(location.hash);
          if (dst.length>0) {
            if (window.innerWidth<901) {
              var module = dst.closest('.module');
              if (module.length==0)
                module = section.find('.module').first();
              switchModule(module);
            }
            $(window).trigger('scroll');
            $.scrollTo(location.hash, 600);
          }
        }
      }

      //after all tasks, scroll to hash position on page load
      scrollToHash();

      $(window).on('mediaChange', function() {
        setTimeout(function() {
          scrollToHash();
        }, 800);
      });
    }
    buildIndex(section);
    section.addClass('initialized');
  }

  //option ignoreOnResize disables the event trigger for 250ms
  this.initScrollHandle = function(options) {
    var scrollTimeoutId = null;
    var ignore = false;
    if (options.ignoreOnResize) {
      $(window).resize(function() {
        ignore = true; 
        setTimeout(function() {
          ignore = false;
        }, 250);
      })
    }
    function scrollHandle() {
      clearTimeout(scrollTimeoutId);
      scrollTimeoutId = setTimeout(function () {
        if (!ignore) {
          $(window).trigger('scrollEnd');
        }
      }, 50);
    }
    $(window).scroll(scrollHandle);
  }
  this.initMediaQueryHandle = function() {
    selfSJS.Media = new function() {
      var media = this;
      var mqS = window.matchMedia("(max-width: 600px)");
      var mqM = window.matchMedia("(max-width: 900px)");
      var mqO = window.matchMedia("(orientation: landscape)");
      var tId = 0;
      function updateMedia() {
        media.isLarge = !mqM.matches;
        media.isMediumUp = !mqS.matches;
        media.isMedium = mqM.matches && !mqS.matches;
        media.isMediumDown = mqM.matches;
        media.isSmall = mqS.matches;
        media.isLandscape = mqO.matches;
      }
      function handler() {
        clearTimeout(tId);
        tId = setTimeout(function() {
          updateMedia();
          $(window).trigger('mediaChange');
        }, 1);
      }
      updateMedia();
      mqS.addListener(handler);
      mqM.addListener(handler);
      mqO.addListener(handler);
      return this;
    }
  }

  this.replaceHash = function(value) {
    var url = location.href.replace(location.hash, '') + value;
    history.replaceState(null, '', url);
  }

  this.addImageFilter = function(imgUrl, filter) {
    var ret = imgUrl.substr(0, imgUrl.lastIndexOf('.')) + '_' + filter + imgUrl.substr(imgUrl.lastIndexOf('.'));
    return ret;
  }
  this.SwatchTextureImageFilter = function(images, filter,default_img) {
    var ret = default_img;
    let arrayLength = images.length;
    for (var i = 0; i < arrayLength; i++) {
      var imagename_array = images[i].split("_");
      var shade_name = imagename_array[imagename_array.length - 1].split(".");
      shade_name = shade_name[0].trim();
      filter = filter.replace(" ", "-")
      if(images[i].indexOf("SWATCH") > -1 && shade_name == filter){
        ret = images[i];
      }
    }
    return ret;
  }
};
window.Simplistic = new SimplisticJS();
window.Simplistic.Swatches = {}
try {
  window.Simplistic.Swatches = {
  "Shade": {
    "M1": {
      "description": "is a matte dusty rose taupe",
      "swatch": "#AD817A"
    },
    "M2": {
      "description": "is a matte bone",
      "swatch": "#E6B8A3"
    },
    "M3": {
      "description": "is a nude blush beige",
      "swatch": "#9F6C63"
    },
    "M4": {
      "description": "is a matte espresso",
      "swatch": "#5B4032",
      "text-color": "#FFFFFF"
    },
    "M5": {
      "description": "is a matte peach beige",
      "swatch": "#C38C74"
    },
    "M6": {
      "description": "is a matte warm beige",
      "swatch": "#C89F8B"
    },
    "M7": {
      "description": "is a watermelon pink",
      "swatch": "#BB4856"
    },
    "M8": {
      "description": "is a matte sable",
      "swatch": "#98715A"
    },
    "M9": {
      "description": "is a peach pink",
      "swatch": "#B9665B"
    },
    "M10": {
      "description": "is a matte soft terracotta",
      "swatch": "#985F51",
      "text-color": "#FFFFFF"
    },
    "M11": {
      "description": "is a carnation pink",
      "swatch": "#B34E58"
    },
    "M12": {
      "description": "is a plum rose",
      "swatch": "#883E4D"
    },
    "M13": {
      "description": "is a rich plum brown",
      "swatch": "#391C16"
    },
    "M14": {
      "description": "is a matte indigo gray",
      "swatch": "#6B6168",
      "text-color": "#FFFFFF"
    },
    "M15": {
      "description": "is a plum pink",
      "swatch": "#EE5C7F"
    },
    "M17": {
      "description": "is a peach",
      "swatch": "#CA8773"
    },
    "M18": {
      "description": "is a matte milk chocolate",
      "swatch": "#996C57",
      "text-color": "#FFFFFF"
    },
    "M19": {
      "description": "is a honey rose",
      "swatch": "#AE7463"
    },
    "M20": {
      "description": "is a brick rose",
      "swatch": "#9E5B57",
      "text-color": "#FFFFFF"
    },
    "M21": {
      "description": "is a coral",
      "swatch": "#D54C49"
    },
    "M22": {
      "description": "is a pink coral",
      "swatch": "#DE4A4E"
    },
    "M23": {
      "description": "is a berry",
      "swatch": "#B44A58"
    },
    "M24": {
      "description": "is a soft berry",
      "swatch": "#91494F"
    },
    "M25": {
      "description": "is a honey rose",
      "swatch": "#975750"
    },
    "M26": {
      "description": "is a dried plum",
      "swatch": "#8A5151",
"text-color": "#ffffff"
    },
    "M27": {
      "description": "is a coral pink",
      "swatch": "#D78B7B"
    },
    "M28": {
      "description": "is a matte violet brown",
      "swatch": "#70564F",
      "text-color": "#FFFFFF"
    },
    "M29": {
      "description": "is a matte red brown",
      "swatch": "#8B5E54",
      "text-color": "#FFFFFF"
    },
    "M30": {
      "description": "is a red coral",
      "swatch": "#EF1A1A"
    },
    "M31": {
      "description": "is a dusty mauve",
      "swatch": "#CB8896"
    },
    "M32": {
      "description": "is a matte gray brown",
      "swatch": "#64544D",
      "text-color": "#FFFFFF"
    },
    "M33": {
      "description": "is a matte guava",
      "swatch": "#CE8B81"
    },
    "M34": {
      "description": "is a chestnut brown",
      "swatch": "#7A5048"
    },
    "M35": {
      "description": "is a dried rose",
      "swatch": "#763B34"
    },
    "M36": {
      "description": "is a rose taupe",
      "swatch": "#A47C6F",
      "text-color": "#FFFFFF"
    },
    "M37": {
      "description": "is a golden brown",
      "swatch": "#9A715C",
      "text-color": "#FFFFFF"
    },
    "M38": {
      "description": "is a matte smoky purple",
      "swatch": "#6E5F70",
      "text-color": "#FFFFFF"
    },
    "M39": {
      "description": "is a matte cobalt blue",
      "swatch": "#334D5D",
      "text-color": "#FFFFFF"
    },
    "M40": {
      "description": "is a matte smoky midnight navy",
      "swatch": "#54525A",
      "text-color": "#FFFFFF"
    },
    "M41": {
      "description": "is black",
      "swatch": "#393839",
      "text-color": "#FFFFFF"
    },
    "M42": {
      "description": "is a rose brown",
      "swatch": "#885F4F",
      "text-color": "#FFFFFF"
    },
    "M43": {
      "description": "is a shimmering champagne",
      "swatch": "#CAA695"
    },
    "M44": {
      "description": "is a lilac taupe sheen",
      "swatch": "#8B736C",
      "text-color": "#FFFFFF"
    },
    "M45": {
      "description": "is a shimmering warm pink",
      "swatch": "#C3988D"
    },
    "M46": {
      "description": "is a shimmering rose gold",
      "swatch": "#AB7269"
    },
    "M47": {
      "description": "is a shimmering bronze gold",
      "swatch": "#AB7E66"
    },
    "M48": {
      "description": "is a shimmering olive",
      "swatch": "#958168"
    },
    "M49": {
      "description": "is a shimmering pink champagne",
      "swatch": "#CEA292"
    },
    "M50": {
      "description": "is a shimmering white gold",
      "swatch": "#ECCFB2"
    },
    "M51": {
      "description": "is a shimmering rose gold",
      "swatch": "#C69480"
    },
    "M52": {
      "description": "is a shimmering copper",
      "swatch": "#AA7A5C",
      "text-color": "#FFFFFF"
    },
    "M53": {
      "description": "clear",
      "swatch": "#E4C78B"
    },
    "M54": {
      "description": "is a chocolate brown",
      "swatch": "#69483C",
      "text-color": "#FFFFFF"
    },
    "M55": {
      "description": "is a plum violet",
      "swatch": "#7E505E"
    },
    "M56": {
      "description": "is a warm soft pink",
      "swatch": "#A96967"
    },
    "M57": {
      "description": "is a mauve rose",
      "swatch": "#995055"
    },
    "M58": {
      "description": "is a faded rose",
      "swatch": "#985E5A"
    },
    "M59": {
      "description": "is a nude warm beige",
      "swatch": "#A95F57"
    },
    "M60": {
      "description": "is a rose taupe brown",
      "swatch": "#885B54"
    },
    "M61": {
      "description": "is a rich coral",
      "swatch": "#AA5956"
    },
    "M62": {
      "description": "is a red",
      "swatch": "#A42826"
    },
    "M63": {
      "description": "is a merlot",
      "swatch": "#963135"
    },
    "M64": {
      "description": "is a matte maroon burgundy",
      "swatch": "#91575B",
"text-color": "#ffffff"
    },
    "M65": {
      "description": "is a matte brown plum",
      "swatch": "#7B4E4C",
      "text-color": "#FFFFFF"
    },
    "Volumizing Mascara": {
      "description": "is black",
      "swatch": "#393839",
      "text-color": "#FFFFFF"
    },
    "M67": {
      "description": "is a cool red",
      "swatch": "#DE282E",
      "text-color": "#FFFFFF"
    },
    "M68": {
      "description": "is a strawberry pink",
      "swatch": "#CD5568"
    },
    "M69": {
      "description": "is a berry plum",
      "swatch": "#AC2053",
"text-color": "#ffffff", 
"hiding_options": ["Palette Builder"]
    },
    "M70": {
      "description": "is a soft coral",
      "swatch": "#F16E5E"
    },
    "M71": {
      "description": "is a deep plum",
      "swatch": "#6D273D",
"text-color": "#ffffff"
    },
    "M72": {
      "description": "is an earthy rose",
      "swatch": "#C2786F"
    },
    "M73": {
      "description": "is a rose mauve",
      "swatch": "#BF6B6D"
    },
    "M74": {
      "description": "is a rosewood",
      "swatch": "#C96C67"
    },
    "M75": {
      "description": "is a hot pink coral",
      "swatch": "#FF4938",
      "text-color": "#FFFFFF",
"hiding_options": ["Palette Builder"]
    },
    "M77": {
      "description": "is a golden brown",
      "swatch": "#9A715C",
      "text-color": "#FFFFFF"
    },
    "M78": {
      "description": "is a rose chocolate brown",
      "text-color": "#FFFFFF",
      "swatch": "#885F4F"
    },
    "M79": {
      "description": "is an espresso brown",
      "swatch": "#69483C",
      "text-color": "#FFFFFF"
    },
    "M80": {
      "description": "is a taupe brown",
      "swatch": "#A47C6F",
      "text-color": "#FFFFFF"
    },
    "M81": {
      "description": "is a cyan blue",
      "swatch": "#52B5CB",
      "text-color": "#FFFFFF"
    },
    "M82": {
      "description": "is a ballet pink",
      "swatch": "#D2948D"
    },
    "M83": {
      "description": "is a lavender",
      "swatch": "#AF93B6"
    },
    "M84": {
      "description": "is a peach coral",
      "swatch": "#CF8774"
    },
    "M85": {
      "description": "is a mint seafoam green",
      "swatch": "#96B39F"
    },
    "M86": {
      "description": "is a butter yellow",
      "swatch": "#EAB881"
    },
    "M87": {
      "description": "is a dove gray",
      "swatch": "#827575",
"text-color": "#ffffff"
    },
    "M88": {
      "description": "is a softest dusty pink",
      "swatch": "#C89A9C"
    },
    "M89": {
      "description": "is midnight blue",
      "swatch": "#2D4053",
"text-color": "#ffffff"
    },
    "M90": {
      "description": "is deep brown",
      "swatch": "#66514D",
"text-color": "#ffffff"
    },
    "M91": {
      "description": "is tulip pink",
      "swatch": "#E782A9"
    },
    "M92": {
      "description": "is a pale peachy-pink",
      "swatch": "#D78B7B"
    },
    "M93": {
      "description": "is a rosy mauve",
      "swatch": "#9C595B"
    },
    "M94": {
      "description": "is a mocha rose",
      "swatch": "#996463"
    },
    "M101": {
      "description": "is a deep plum garnet",
      "swatch": "#673F3A",
"text-color": "#ffffff"
    },
    "M102": {
      "description": "is a mauve greige",
      "swatch": "#87695E"
    },
    "M103": {
      "description": "is a olive mustard",
      "swatch": "#9B6D39"
    },
    "M104": {
      "description": "is a terracotta",
      "swatch": "#8A442B",
"text-color": "#ffffff"
    },
    "M105": {
      "description": "is a burnt sienna",
      "swatch": "#773D29",
"text-color": "#ffffff"
    },
    "M106": {
      "description": "is a deep green peacock",
      "swatch": "#3F413A",
"text-color": "#ffffff"
    },
    "M107": {
      "description": "is a golden wheat",
      "swatch": "#AE8165"
    },
    "M96": {
      "description": "is a glassy golden copper",
      "swatch": "#875536",
"text-color": "#ffffff"
    },
    "M97": {
      "description": "is a glassy rose gold",
      "swatch": "#BF7B65"
    },
    "M98": {
      "description": "is a glassy naked champagne",
      "swatch": "#BA9380"
    },
    "M99": {
      "description": "is a glassy iridescent",
      "swatch": "#CBBCAA"
    },
    "M100": {
      "description": "is a brick rose",
      "swatch": "#8C4F45"
    },
    "M95": {
      "description": "is a deep amethyst plum",
      "swatch": "#71504F"
    },
    "M189": {
      "description": "is a muted crimson",
      "swatch": "#891917"
    },
    "Pink 20": {
      "description": "is fair to light with cool pink undertones",
      "swatch": "#D8AA92"
    },
    "Pink 30": {
      "description": "is light with cool pink undertones",
      "swatch": "#D2A287"
    },
    "Pink 40": {
      "description": "is medium-light with cool pink undertones",
      "swatch": "#CC9A7E"
    },
    "Pink 50": {
      "description": "is medium with rosy pink undertones",
      "swatch": "#C19278"
    },
    "Neutral 0": {
      "description": "is fairest porcelain with neutral undertones",
      "swatch": "#E2BCA7"
    },
    "Neutral 10": {
      "description": "is fair with neutral undertones",
      "swatch": "#DAB49C"
    },
    "Neutral 20": {
      "description": "is fair to light with neutral undertones",
      "swatch": "#D6AC92"
    },
    "Neutral 30": {
      "description": "is light with neutral undertones",
      "swatch": "#D0A387"
    },
    "Neutral 40": {
      "description": "is medium-light with neutral undertones",
      "swatch": "#C89B7D"
    },
    "Neutral 50": {
      "description": "is medium with neutral undertones",
      "swatch": "#C19273"
    },
    "Neutral 60": {
      "description": "is medium to tan with neutral undertones",
      "swatch": "#B98768"
    },
    "Neutral 70": {
      "description": "is caramel light brown with neutral undertones",
      "swatch": "#B07F61"
    },
    "Neutral 80": {
      "description": "is medium brown with neutral undertones",
      "swatch": "#A77758"
    },
    "Neutral 85": {
      "description": "is medium-dark with neutral undertones",
      "swatch": "#986C53"
    },
    "Neutral 90": {
      "description": "is warm dark with neutral undertones",
      "swatch": "#8D6149"
    },
    "Neutral 95": {
      "description": "is warm deep with neutral undertones",
      "swatch": "#815944"
    },
    "Neutral 100": {
      "description": "is deep with neutral undertones",
      "swatch": "#705040"
    },
    "Neutral 110": {
      "description": "is deep espresso with neutral undertones",
      "swatch": "#65493D"
    },
    "Neutral 120": {
      "description": "is deep ebony with neutral undertones",
      "swatch": "#5C443A"
    },
    "Gold 10": {
      "description": "is fairest porcelain with gold undertones",
      "swatch": "#DBB49B"
    },
    "Gold 20": {
      "description": "is fair to light with gold undertones",
      "swatch": "#D5AD90"
    },
    "Gold 30": {
      "description": "is light with gold undertones",
      "swatch": "#CFA484"
    },
    "Gold 40": {
      "description": "is medium-light with gold undertones",
      "swatch": "#C79C7E"
    },
    "Gold 50": {
      "description": "is medium with gold undertones",
      "swatch": "#C09270"
    },
    "Gold 60": {
      "description": "is medium to tan with gold undertones",
      "swatch": "#BB8764"
    },
    "Gold 70": {
      "description": "is medium-light brown with golden undertones",
      "swatch": "#B07F5E"
    },
    "Gold 80": {
      "description": "is medium brown with golden undertones",
      "swatch": "#A77755"
    },
    "Gold 85": {
      "description": "is medium-dark with golden undertones",
      "swatch": "#9A6D4D"
    },
    "Gold 90": {
      "description": "is warm dark with gold undertones",
      "swatch": "#8E6549"
    },
    "Gold 95": {
      "description": "is warm deep with golden undertones",
      "swatch": "#825A40"
    },
    "Olive 30": {
      "description": "is light with olive undertones",
      "swatch": "#D2A27E"
    },
    "Olive 40": {
      "description": "is medium-light with olive undertones",
      "swatch": "#C89B77"
    },
    "Olive 50": {
      "description": "is medium with olive undertones",
      "swatch": "#C09470"
    },
    "Olive 60": {
      "description": "is medium to tan with olive undertones)",
      "swatch": "#BA8C69"
    },
    "Olive 70": {
      "description": "is medium-light brown with olive undertones",
      "swatch": "#AD815F"
    },
    "Olive 80": {
      "description": "is medium brown with olive undertones",
      "swatch": "#A57959"
  },
    "M109": {
      "description": "is a chartreuse green",
      "swatch": "#a5853a"
 },
    "M110": {
      "description": "is a deep maroon burgundy",
      "swatch": "#54393b",
"text-color": "#ffffff"
},
    "M111": {
      "description": "is a lavender stone",
      "swatch": "#937174"
},
    "M112": {
      "description": "is a soft mushroom",
      "swatch": "#9f7e6c"
},
    "M113": {
      "description": "golden camel",
      "swatch": "#9d6436"
},
    "M114": {
      "description": "is a muted rose",
      "swatch": "#9b5a4e"
},
    "M115": {
      "description": "is a taupe",
      "swatch": "#986d5a"
},
    "M119": {
      "description": "is a honeyed beige",
      "swatch": "#f6b092"
},
    "M120": {
      "description": "is a blackened oxblood",
      "swatch": "#52322a"
},
    "M117": {
      "description": "is a peach pink",
      "swatch": "#d17969"
},
    "M118": {
      "description": "is a soft pumpkin",
      "swatch": "#d27751"
},
    "M121": {
      "description": "is a soft yellow",
      "swatch": "#ECB76F",
"hiding_options": ["Palette Builder"]
},
    "M122": {
      "description": "is a matte soft yellow",
      "swatch": "#F9D88C",
"hiding_options": ["Palette Builder"]
},
    "M121+M122": {
      "description": "is a soft yellow duo",
      "swatch": "#ECB76F"
},
    "M123": {
      "description": "is a soft peach",
      "swatch": "#D58D72"
},
    "M124": {
      "description": "is a matte soft peach",
      "swatch": "#E89E82"
},
    "M123+M124": {
      "description": "is a soft peach duo",
      "swatch": "#D58D72"
},
    "M125": {
      "description": "is a soft pink",
      "swatch": "#DC979A"
},
    "M126": {
      "description": "is a matte soft pink",
      "swatch": "#F4B7BD"
},
    "M125+M126": {
      "description": "is a soft pink duo",
      "swatch": "#DC979A"
},
    "M127": {
      "description": "is a soft brick",
      "swatch": "#BC6755"
},
    "M128": {
      "description": "is a matte soft brick",
      "swatch": "#DB7B65"
},
    "M127+M128": {
      "description": "is a soft brick duo",
      "swatch": "#BC6755"
},
    "M129": {
      "description": "is a sparkling pearl",
      "swatch": "#E7E8EB"
},
    "M130": {
      "description": "is a sparkling rose gold",
      "swatch": "#D7BEA6"
},
    "M116": {
      "description": "is a deep peacock",
      "swatch": "#3f413a",
"text-color": "#ffffff"
},    
    "Deep": {
      "description": "is for deeper skin tones",
      "swatch": "#705040"
},
    "Medium": {
      "description": "is for medium skin tones",
      "swatch": "#c19273"
},
    "Translucent": {
      "description": "is universal",
      "swatch": "#e2bca7"
},
    "Pink": {
      "description": "is pink",
      "swatch": "#ebcece"
},
    "M131": {
      "description": "is a matte marine blue",
      "swatch": "#2D4793",
"hiding_options": ["Palette Builder"]
},
    "M132": {
      "description": "is a matte sunset golden orange",
      "swatch": "#E19D5B",
"hiding_options": ["Palette Builder"]
},
    "M133": {
      "description": "is a shimmering pale gold champagne",
      "swatch": "#F8E2A1",
"hiding_options": ["Palette Builder"]
},
    "M134": {
      "description": "is a shimmering pewter teal",
      "swatch": "#2B4A5B",
"hiding_options": ["Palette Builder"]
},
    "M147": {
      "description": "is a chocolate port",
      "swatch": "#3C2223"
},
    "M154": {
      "description": "is a pale peachy beige",
      "swatch": "#C38681"
},
    "M154B": {
      "description": "is a pale cool beige",
      "swatch": "#C3988D"
},
    "M166": {
      "description": "is a mahogany red",
      "swatch": "#572728"
},
    "M155": {
      "description": "is a muted amethyst",
      "swatch": "#7C5454"
},
    "M156": {
      "description": "is an olive",
      "swatch": "#655939"
},
    "M157": {
      "description": "is a red soil",
      "swatch": "#67392E"
},
    "M158": {
      "description": "is a cocoa",
      "swatch": "#79524C"
},
    "M163": {
      "description": "is a sparkling chartreuse",
      "swatch": "#A2A891"
},
    "M159": {
      "description": "is a cool taupe brown",
      "swatch": "#856e6e"
},
    "M138": {
      "description": "is a sheer black",
      "swatch": "#322223"
},
    "M139": {
      "description": "is a cool nude",
      "swatch": "#925F4C"
},
    "M140": {
      "description": "is eggplant",
      "swatch": "#310B31",
"text-color": "#ffffff"
},
    "M141": {
      "description": "is a smoky cornflower blue",
      "swatch": "#8DA6B8"
},
    "M160": {
      "description": "is a icy white shimmer",
      "swatch": "#E7E7E5"
},
    "Black": {
      "description": "is a black",
      "swatch": "#131A21",
      "text-color": "#FFFFFF"
},
    "Shadowplay": {
      "description": "is a matte smoky sage gray",
      "swatch": "#495056",
      "text-color": "#FFFFFF"
},
    "Blanc": {
      "description": "is a matte white",
      "swatch": "#F5FCFF"
},
    "Milky Way": {
      "description": "is a smoky amethyst shimmer",
      "swatch": "#807990"
},
    "Haze": {
      "description": "is a soft hazy heather",
      "swatch": "#7C6761"
},
    "M161": {
      "description": "is a sandy taupe shimmer",
      "swatch": "#CBAC9D"
},
    "M162": {
      "description": "is a gunmetal shimmer",
      "swatch": "#9DA1A5"
},
    "M164": {
      "description": "is a chocolate espresso",
      "swatch": "#5F4020"
},
    "M165": {
      "description": "is a cerulean blue",
      "swatch": "#4C92BB"
},
    "M171": {
      "description": "is a mocha",
      "swatch": "#A47864"
},
    "Latex": {
      "description": "is a soft ochre",
      "swatch": "#AAA377"
},
    "The White": {
      "description": "is a neutral white",
      "swatch": "#E7E7E5"
},
    "Paradox- M174": {
      "description": "is a pale pink",
      "swatch": "#C6A8AC"
},
    "Frostbite- M175": {
      "description": "is a smoky silver",
      "swatch": "#C9C2C0"
},
    "Moonchild- M176": {
      "description": "is a smoky plum",
      "swatch": "#5F3133"
},
    "Magnolia Blvd.- M177": {
      "description": "is a rose gold",
      "swatch": "#D38B78"
},
    "Dark Star": {
      "description": "is a gunmetal sparkle",
      "swatch": "#605A5A"
},
    "Breakdown": {
      "description": "is a golden neutral beige",
      "swatch": "#8D5F34"
},
    "Diamond Star Halo": {
      "description": "is a clear sparkle",
      "swatch": "#E7E8EB"
},
    "M167": {
      "description": "is a red magenta shimmer",
      "swatch": "#CB2424"
},
    "M168": {
      "description": "is a bronze copper shimmer",
      "swatch": "#88654F"
},
    "M169": {
      "description": "is a red cranberry",
      "swatch": "#CB2424"
},
    "M170": {
      "description": "is a soft neutral brown",
      "swatch": "#9C724E"
},
    "M145": {
      "description": "is a champagne shimmer",
      "swatch": "#BAAA97"
},
    "M146": {
      "description": "is a amethyst shimmer",
      "swatch": "#8F869B"
},
    "M142": {
      "description": "is sage",
      "swatch": "#96947D"
},
    "M143": {
      "description": "is a black denim",
      "swatch": "#3E414D",
"text-color": "#ffffff"
},
"M144": {
      "description": "is a muted rose",
      "swatch": "#B34B44"
},
"M1990": {
      "description": "is a cool tone neutral",
      "swatch": "#A36663"
},
"M148": {
      "description": "is a wet concrete",
      "swatch": "#463D32"
},
"M149": {
      "description": "is a sheer icy blue",
      "swatch": "#90A8B4"
},
"M150": {
      "description": "is an electric hot pink",
      "swatch": "#B62649",
"text-color": "#ffffff"
},
"M151": {
      "description": "is a deep sea blue",
      "swatch": "#121518",
"text-color": "#ffffff"
},
"M152": {
      "description": "is a chartreuse mustard",
      "swatch": "#A4902E",
"text-color": "#ffffff"
},
"Universal": {
      "description": "is colorless",
      "swatch": "#FAF9F6",
"text-color": "#ffffff"
},
"M153": {
      "description": "is a sepia brown",
      "swatch": "#75423A",
"text-color": "#ffffff"
},
    "M136": {
      "description": "is a warm fire red",
      "swatch": "#BC3C35"
    },
    "Crimson Crush": {
      "description": "is a muted crimson",
      "swatch": "#891917"
    },
    "Redemption": {
      "description": "is a muted merlot red",
      "swatch": "#951525"
    },
    "Wine Knot": {
      "description": "is a deep garnet",
      "swatch": "#5F3637"
    },
    "Reverb": {
      "description": "is a shimmering emerald peacock",
      "swatch": "#1A4637"
    },
    "Riff": {
      "description": "is a blushing beige",
      "swatch": "#c8837c"
    },
    "Whimsy": {
      "description": "is a shimmering magenta purple",
      "swatch": "#C289AF",
},
    "Memento": {
      "description": "is a camel brown",
      "swatch": "#C88A6A",
},
    "Linger": {
      "description": "is a chocolate",
      "swatch": "#975E4B"
},
    "Soft Rose": {
      "description": "is a soft rose",
      "swatch": "#D5514F"
},
    "Bitten": {
      "description": "is a muted cherry",
      "swatch": "#C12A0B"
},
    "Lavender": {
      "description": "is a lavender lilac",
      "swatch": "#CC98C8"
},
    "Infatuation": {
      "description": "is a muted lilac lavender",
      "swatch": "#CC98C8"
},
    "Linen": {
      "description": "is a matte soft bone",
      "swatch": "#B78E6C"
},
    "Dusty Rose": {
      "description": "is a matte rose taupe",
      "swatch": "#82564A"
},
    "Driftwood": {
      "description": "is a matte soft brown taupe",
      "swatch": "#6C4D37"
},
    "Chocolate": {
      "description": "is a matte chocolate brown",
      "swatch": "#3E281B"
},
    "Burgundy": {
      "description": "is a burgundy",
      "swatch": "#50161A"
    }
  },
  "Compact": {
    "_info": "<div>Ingredients</div><p>Lorem ipsum dolor sit amet, consectetur elit, dolor sit amet adipiscing elit sed.</p>",
    "RePurpose Compact": {
      "description": "is a lorem ipsum 123",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "NewPurpose Compact": {
      "description": "is a lorem ipsum 456 dolor sit",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "Refill Only": {
      "description": "is a lorem ipsum 789 dolor sit amet",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_refill_rect.jpg?v=1597263918"
    }
  },
  "Capsule": {
    "_info": "<div>Ingredients</div><p>Lorem ipsum dolor sit amet, consectetur elit, dolor sit amet adipiscing elit sed.</p>",
    "RePurpose Capsule": {
      "description": "is a lorem ipsum dolor sit",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "NewPurpose Capsule": {
      "description": "is a lorem ipsum dolor",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "Refill Only": {
      "description": "is a lorem ipsum",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_refill_rect.jpg?v=1597263918"
    }
  },
  "Size": {
    "1": {
      "description": "",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/products/COMPACT1__OPEN_EMPTY_RESIZED_200x.jpg?v=1602770999"
    },
    "Compact 1+": {
      "description": "",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/products/COMPACT1__OPEN_EMPTY_RESIZED_200x.jpg?v=1602770999"
    },
    "Palette 4+": {
      "description": "",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/products/PALETTE4__OPEN_EMPTY_RESIZED_200x.jpg?v=1602770999"
    },
    "Palette 6+": {
      "description": "",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/products/PALETTE6__OPEN_EMPTY_RESIZED_200x.jpg?v=1602770999"
    },
    "1+": {
      "description": "",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/products/COMPACT1__OPEN_EMPTY_RESIZED_200x.jpg?v=1602770999"
    }
  },
  "Material": {
    "RePurpose": {
      "description": "is a material lorem ipsum",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "NewPurpose": {
      "description": "is a material brand new lorem ipsum",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    }
  },
  "Compact or Refill": {
    "_info": "<div>Packaging Sold Separately</div><p>Choose the Compact option to receive both the shade Refill and the Compact, or choose Refill Only if you already have a MOB Compact or Palette.</p>",
    "RePurpose Compact": {
      "description": "- All MOB Compacts are endlessly refillable and made with post-consumer materials",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "NewPurpose Compact": {
      "description": "is a lorem ipsum 456 dolor sit",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "Refill Only": {
      "description": "fit into all MOB Compacts and Palettes",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_refill_rect.jpg?v=1597263918"
    }
  },
  "Lip Capsule or Refill": {
    "_info": "<div>Packaging Sold Separately</div><p>Choose the Capsule option to receive both the shade Refill and the Capsule, or choose Refill Only if you already have a MOB Capsule.</p>",
    "RePurpose Lip Capsule": {
      "description": "is endlessly refillable and made with post-consumer recycled materials.",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "NewPurpose Lip Capsule": {
      "description": "is a lorem ipsum dolor",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "Refill Only": {
      "description": "fit into MOB Lip Capsule",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_refill_rect.jpg?v=1597263918"
    }
  },
  "Compact + Refill or Refill Only": {
    "_info": "<div>Packaging Sold Separately</div><p>Choose the Compact option to receive both the shade Refill and the Compact, or choose Refill Only if you already have a MOB Compact or Palette.</p>",
    "RePurpose Compact + Refill": {
      "description": "- All MOB Compacts are endlessly refillable and made with post-consumer materials",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "NewPurpose Compact": {
      "description": "is a lorem ipsum 456 dolor sit",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "Refill Only": {
      "description": "fit into all MOB Compacts and Palettes",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_refill_rect.jpg?v=1597263918"
    }
  },
  "Lip Capsule + Refill or Refill Only": {
    "_info": "<div>Packaging Sold Separately</div><p>Choose the Capsule option to receive both the shade Refill and the Capsule, or choose Refill Only if you already have a MOB Capsule.</p>",
    "RePurpose Lip Capsule + Refill": {
      "description": "is endlessly refillable and made with post-consumer recycled materials.",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "NewPurpose Lip Capsule": {
      "description": "is a lorem ipsum dolor",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_purpose_rect.jpg?v=1597263918"
    },
    "Refill Only": {
      "description": "fit into MOB Lip Capsule",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/swatch_refill_rect.jpg?v=1597263918"
    }
  },
  "Skin Tone": {
    "Light Skin Tones": {
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/light_skin_tone_ty.jpg?v=1628010723"
    },
    "Medium Skin Tones": {
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/medium_skin_tone_ty.jpg?v=1628010722"
    },
    "Deep Skin Tones": {
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/deep_skin_tone_ty.jpg?v=1628010722"
    }
  },
  "Add Makeup Step": {
    "Suggested Palettes": {
      "step_caption": "Suggested Palettes",
      "label": "Explore Suggested Palettes",
      "Compact 1+": {
        "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/suggested_palettes_swatch.jpg?v=1628864256"
      },
      "Palette 4+": {
        "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/4___Suggested_Palette_Thumbnail_200x230_40f2a27d-af67-4a70-9a9a-138620e2c768.jpg?v=1632153854"
      },
      "Palette 6+": {
        "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/6___Suggested_Palette_Thumbnail_200x230_9d9532b1-7dab-4b81-a423-18ae72f81b09.jpg?v=1632153988"
      }
    },
    "Fill Your Own": {
      "step_caption": "Custom Palette",
      "label": "Build Your Own Palette",
      "Compact 1+": {
        "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/products/COMPACT1__OPEN_EMPTY_RESIZED_200x.jpg?v=1628702682"
      },
      "Palette 4+": {
        "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/products/PALETTE4__OPEN_EMPTY_RESIZED_200x.jpg?v=1628702682"
      },
      "Palette 6+": {
        "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/products/PALETTE6__OPEN_EMPTY_RESIZED_200x.jpg?v=1628702682"
      }
    }
  },
  "Capsule + Refill or Refill Only": {
    "_info": "<div>Packaging Sold Separately</div><p>Choose the Capsule option to receive both the Mascara Refill and the Capsule, or choose Refill Only if you already have a MOB Mascara Capsule.</p>",
    "RePurpose Mascara Capsule + Refill": {
      "description": "includes an endlessly refillable Mascara Capsule + Mascara Refill. Both made with post-consumer recycled materials.",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/MOB_PDP_MASC_SLIDER_PRODUCT_CAPSULE_CLOSED_M66.jpg?v=1633359583"
    },
    "Refill Only": {
      "description": "are made with 100% post-consumer recycled material and snap into the Mascara Capsule",
      "swatch": "https://cdn.shopify.com/s/files/1/0272/5720/8877/files/MOB_PDP_MASC_SLIDER_PRODUCT_REFILL_OPEN_M66.jpg?v=1633359584"
    }
  }
};
} catch (e) {
  console.error('Swatches config broken', e);
}

$(function() {
  Simplistic.initProductItems();
})

function userAuthenticationPopup() {
  var body = $('body');
  var popup = document.getElementById('authentication-popup');
  var panels;
  if (!popup) {
    var html = $('<div id="authentication-popup" style="display: none;"><div class="authentication-panels"><div class="loader"></div></div></div>');
    var tab1 = $('<input type="radio" name="authentication-tab" id="authentication-tab-login" class="visuallyhidden" checked value="login-page-login" /><label class="tab-selector" for="authentication-tab-login">Login</label>');
    var tab2 = $('<input type="radio" name="authentication-tab" id="authentication-tab-register" class="visuallyhidden" value="login-page-register" /><label class="tab-selector" for="authentication-tab-register">Register</label>');

    body.append(html);
    popup = $('#authentication-popup');
    var panels = popup.find('.authentication-panels');
    var loginAjax = $.get('/account/login?view=ajax');
    var registerAjax = $.get('/account/register?view=ajax');
    Simplistic.openModal(panels, 'authentication-popup');

    function panelVisibility() {
      var panelName = panels.find('[name="authentication-tab"]:checked').val();
      panels.find('.login-page').hide();
      panels.find('.login-page.'+panelName).show();
    }
    loginAjax.done(function(logindata) {
      registerAjax.done(function(data) {
        panels.append($('<h2 class="title body_font">My Account</h2>'));
        panels.append(tab1).append(tab2);
        panels.find('[name="authentication-tab"]').change(panelVisibility);
        panels.find('.loader').remove();
        panels.append(logindata);
        panels.append(data);
        panelVisibility()
      });
    });
  } else {
    popup = $(popup);
    panels = popup.find('.authentication-panels');
    Simplistic.openModal(panels, 'authentication-popup');
  }
}